import { Message, Sms, Whatsapp } from 'iconsax-react';

import { REMINDER_CHANNELS } from '@src/shared/types/reminder';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';

function normalizeChannel(ch: string) {
  return ch.trim().toUpperCase();
}

export function ReminderChannelCell({ channel }: { channel: string }) {
  const c = normalizeChannel(channel);
  if (c === REMINDER_CHANNELS.whatsapp || c === 'WHATSAPP') {
    return (
      <span className='inline-flex items-center gap-1 text-sm font-medium text-gray-1000'>
        <Whatsapp
          size={20}
          variant='Bold'
          color='#2EA844'
        />
        {formatTextForDisplay(channel)}
      </span>
    );
  }
  if (c === REMINDER_CHANNELS.sms || c === 'SMS') {
    return (
      <span className='inline-flex items-center gap-1 text-sm font-medium text-gray-1000'>
        <Message
          size={20}
          variant='Bold'
          color='#3B82F6'
        />

        {formatTextForDisplay(channel)}
      </span>
    );
  }
  return (
    <span className='inline-flex items-center gap-1 text-sm font-medium text-gray-1000'>
      <Sms
        size={20}
        variant='Bold'
        color='#DE483B'
      />
      {formatTextForDisplay(channel)}
    </span>
  );
}
